export const calendarTimeslotRef = 'calendar-timeslot';
export const durationOptions = [
  { value: '', name: '- Select Duration -', disabled: true },
  {
    value: '15_MINS',
    name: '15 Minutes (Fixed)',
  },
  {
    value: '30_MINS',
    name: '30 Minutes (Fixed)',
  },
  {
    value: '60_MINS',
    name: '1 Hour (Fixed)',
  },
];
export const timeslotFormatOptions = [
  { value: '', name: '- Select Timeslot Format -', disabled: true },
  {
    value: '24_HOURS',
    name: '24 Hours (Default: e.g., 13:00)',
  },
  {
    value: '12_HOURS',
    name: '12 Hours (e.g., 1:00 PM)',
  },
];
